import { Button, Text } from '@chakra-ui/react';
import Link from 'next/link';
import { FC, ReactNode } from 'react';
import { Trans } from 'react-i18next';

const LogInLink: FC<{ children?: ReactNode }> = ({ children }) => (
  <Button as={Link} href="/log-in" variant="link" ml={2} color="black" type="button">
    {children}
  </Button>
);

export const AlreadyHaveAccount: FC = () => {
  return (
    <Trans
      i18nKey="createAccount.basicInfo.existing"
      components={{
        text: <Text color="gray.600" mt={16} />,
        hyperlink: <LogInLink />,
      }}
    />
  );
};
